<template>
  <div class="relative mb-12">
    <router-link :to="localeLink(path)">
      <base-bg-image :image="thumb" :cover="true" />
      <h4 class="mt-3 text-2xl uppercase leading-tight truncate">
        <base-time-text :item="item"/>
        <span>{{ title }}</span>
      </h4>
      <div class="mb-1 text-2xl uppercase leading-tight flex">
        <base-dates :item="item"/>
      </div>
      <p class="serif text-xs uppercase truncate">
        {{ types }}
        <span v-if="types.length && assemblies.length"> • </span>
        {{ assemblies }}
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BaseListItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    thumb () {
      return this.item.thumbnail || this.item.media
    },
    title () {
      return this.item.title
    },
    types () {
      if (!this.item.types) return ''
      return this.item.types.map(t => t.title).join(', ')
    },
    path () {
      return '/' + this.item.uri
    },
    assemblies () {
      if (!this.item.assemblies) return ''
      return this.item.assemblies.map(a => a.title).join(', ')
    }
  }
}
</script>

<style lang="stylus">
  .absolute-center
    left: 50%
    transform: translateX(-50%)
</style>
